import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { useSidebar } from '../contexts/SidebarContext';

// Hosts Sidebar with its required UI state so it can be mounted globally
const GlobalSidebar = () => {
  const { isOpen, close } = useSidebar();

  const [activeTab, setActiveTab] = useState('overview');
  const [expandedSections, setExpandedSections] = useState({
    hire: true,
    manage: false,
    retain: false,
    settings: false,
    'settings-templates': false,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <div className="md:hidden">
      <Sidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        expandedSections={expandedSections}
        toggleSection={toggleSection}
        isOpen={isOpen}
        onOverlayClick={close}
        onItemClick={close}
      />
    </div>
  );
};

export default GlobalSidebar;
